
import Vue from 'vue'
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import PrivacyContent from './PrivacyContent.vue';

@Component({
    components: {
        PrivacyContent,
    }
})
export default class Privacy extends Vue {
    @Prop({
        required: true,
        type: Boolean,
    })
    public value!: boolean;    
    public dialogOpen!: boolean;
}
